import { MouseEvent, useEffect, useState } from 'react';
import Loader from '@/components/common/Loader';
import { IoCloseSharp } from 'react-icons/io5';

interface GameSessionModalProps {
  url: string;
  isOpen: boolean;
  onClose: () => void;
}

export default function GameSessionModal({ url, isOpen, onClose }: GameSessionModalProps) {
  const [isFrameLoading, setIsFrameLoading] = useState(true);

  useEffect(() => {
    if (!isOpen) return;

    setIsFrameLoading(true);
  }, [isOpen]);

  const handleBackdropClick = (event: MouseEvent<HTMLDivElement>) => {
    if (event.target === event.currentTarget) onClose();
  };

  if (!isOpen || !url) return null;

  return (
    <div
      className="fixed left-0 right-0 bottom-0 z-[100] h-[calc(100dvh-3rem)] flex justify-center"
      onClick={handleBackdropClick}
    >
      <div className="relative flex h-full w-full max-w-[30rem] flex-col overflow-hidden bg-black shadow-2xl">
        <button
          onClick={onClose}
          className="absolute top-2 left-1/2 -translate-x-1/2 z-50 flex h-[1.8rem] items-center gap-1 rounded-full bg-gradient-to-r from-yellow-600 to-primary pl-1.5 pr-1 opacity-30 hover:opacity-100"
        >
          <span className="text-[0.9rem] font-medium text-white">Close</span>

          <span className="flex size-[4] p-0.5 items-center justify-center rounded-full bg-yellow-600">
            <IoCloseSharp className="text-base text-white" />
          </span>
        </button>
        
        <div className="relative min-h-0 flex-1 bg-black">
          {isFrameLoading && (
            <Loader className="absolute inset-0 flex items-center justify-center" />
          )}

          <iframe
            key={url}
            src={url}
            title="Casino game session"
            className="h-full w-full border-0"
            allow="autoplay; fullscreen; clipboard-write"
            onLoad={() => setIsFrameLoading(false)}
          />
        </div>
      </div>
    </div>
  );
}
